import React, { useEffect, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { AppUseNotification } from "app/pages/component/AppUseNotification";
import { getAppSettings } from "sr/utils/api/app-settings/appSettings";
import { useDispatch } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { fetchAppSettings } from "sr/redux/reducers/appSettings";
export const MainWrapper = ({ children, ...props }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [isOpen, setIsOpen] = useState(false);
  const HandleOpen = () => {
    setIsOpen(!isOpen);
  };

  // const fetchAppSettings = async () => {
  //   try {
  //     const res = await getAppSettings();
  //     if (res?.success === true) {
  //       localStorage.setItem("appSettings", JSON.stringify(res?.data));
  //       // setAllMessage(res?.data);
  //     }
  //   } catch (e) {}
  // };
  useEffect(() => {
    dispatch(fetchAppSettings());
    // (async () => {
      // const res = await fetchAppSettings();
    // })();
    return () => {};
  }, []);

  return (
    <>
      <AppUseNotification></AppUseNotification>
      <Sidebar isOpen={isOpen} HandleOpen={HandleOpen} />
      <Header isOpen={isOpen} HandleOpen={HandleOpen} />
      {props.topHeader && props.topHeader}
      <main
        className={`${
          isOpen ? "lg:pl-52 " : "lg:pl-20"
        } duration-300 bg-white lg:px-8 px-5`}
      >
        {children}
      </main>
    </>
  );
};
